import styled from 'styled-components';

import { Checkbox } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderContinuationFormBeanPart,
   MedicalDeviceOrderFormRegister,
} from '../medicalDeviceOrder.types';

type ContinuationFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderContinuationFormBeanPart>;
};

const StyledCheckbox = styled(Checkbox)`
   display: flex;
`;
StyledCheckbox.displayName = 'StyledContinuationFieldCheckbox';

export const ContinuationField = (props: ContinuationFieldProps): JSX.Element => {
   return (
      <StyledCheckbox
         testId={'continuation'}
         label={medicalDevicesTranslationKeys.fields.continuation}
         controller={props.register('continuation')}
      />
   );
};
